//images
import en from "./../assets/images/flags/gb.svg";
import r from "./../assets/images/flags/r.svg";
import ua from "./../assets/images/flags/ua.svg";
import es from "./../assets/images/flags/es.svg";
import kr from "./../assets/images/flags/kr.svg";
import tr from "./../assets/images/flags/tr.svg";
import fr from "./../assets/images/flags/fr.svg";
import el from "./../assets/images/flags/gr.svg";
import th from "./../assets/images/flags/th.svg";
import vn from "./../assets/images/flags/vn.svg";
import id from "./../assets/images/flags/id.svg";
import cn from "./../assets/images/flags/cn.svg";
import pt from "./../assets/images/flags/pt.svg";
import eg from "./../assets/images/flags/eg.svg";

export interface ILanguageItem {
  lang: string;
  label: string;
  code: string;
  flag: any;
};

export const REACT_APP_LANGUAGES: string = process.env.REACT_APP_LANGUAGES || "[]";
export const availableBrandLanguages = JSON.parse(REACT_APP_LANGUAGES);

export const RTL_LANGUAGES = ['ar'];

const languages: ILanguageItem[] = [
  {
    lang: 'en',
    label: 'English',
    code: 'en_US',
    flag: en,
  },
  {
    lang: 'uk',
    label: 'Ukrainian',
    code: 'uk_UA',
    flag: ua,
  },
  {
    lang: 'ru',
    label: 'Russian',
    code: 'ru_RU',
    flag: r,
  },
  {
    lang: 'es',
    label: 'Spanish',
    code: 'es_ES',
    flag: es,
  },
  {
    lang: 'ko',
    label: 'Korean',
    code: 'ko_KR',
    flag: kr,
  },
  {
    lang: 'tr',
    label: 'Turkish',
    code: 'tr_TR',
    flag: tr,
  },
  {
    lang: 'el',
    label: 'Greek',
    code: 'el_GR',
    flag: el,
  },
  {
    lang: 'fr',
    label: 'French',
    code: 'fr_FR',
    flag: fr,
  },
  {
    lang: 'th',
    label: 'Thai',
    code: 'th_TH',
    flag: th,
  },
  {
    lang: 'vi',
    label: 'Vietnamese',
    code: 'vi_VN',
    flag: vn,
  },
  {
    lang: 'id',
    label: 'Indonesian',
    code: 'id_ID',
    flag: id,
  },
  {
    lang: 'zh',
    label: 'Chinese',
    code: 'zh_CN',
    flag: cn,
  },
  {
    lang: 'pt',
    label: 'Portuguese',
    code: 'pt_PT',
    flag: pt,
  },
  {
    lang: 'ar',
    label: 'Arabic',
    code: 'ar_EG',
    flag: eg,
  }
];
export default languages

export const availableLanguages = languages.reduce((acc: ILanguageItem[], item: ILanguageItem) => {
  if (availableBrandLanguages.includes(item.lang)) {
    acc.push(item);
  }
  return acc;
}, []);
